import { NameDescriptionForm } from './name-description.constant';

export const SportsCategoriesForm = NameDescriptionForm;